import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import {  FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCoffee, faBars, faUser, faSignOutAlt ,faGear, faHome} from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-siderbar',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterLink,RouterLinkActive,FontAwesomeModule],
  templateUrl: './siderbar.component.html',
  styleUrl: './siderbar.component.scss'
})
export class SiderbarComponent {
  constructor(library:FaIconLibrary) {
    library.addIcons(faCoffee, faBars, faUser, faSignOutAlt,faGear,faHome);
  }

  private authService=inject(AuthService);
logOut() {
 this.authService.logout();
}

}
